import { useQueryClient } from '@tanstack/react-query';
import tw from 'twin.macro';

import type { Note as TNote } from '@restworld/utility-types';
import { SkeletonEmployerCardLoading } from '@restworld/ui-ds';

import { useNoteQueryKey } from '.';
import { CandidateNoteItem } from './candidate-note-item';

export const CandidateNotesList = () => {
  const queryClient = useQueryClient();
  const notesQueryKey = useNoteQueryKey();
  const notesList = queryClient.getQueryData<TNote[]>(notesQueryKey);
  const isPending = queryClient.getQueryState(notesQueryKey)?.status === 'pending';

  return (
    <Wrapper>
      {isPending ? (
        <SkeletonEmployerCardLoading />
      ) : (
        notesList?.map((note) => <CandidateNoteItem key={note.id} {...note} />)
      )}
    </Wrapper>
  );
};
const Wrapper = tw.div`pb-5 min-h-[calc(100vh - 21.5rem)] md:(h-[calc(100vh - 21.5rem)] pb-0 overflow-auto) relative`;
